import React, { createContext, useState, useEffect } from 'react';
import firebase, { db } from '../firebase/base';

export const FavoritesContext = createContext();

const FavoritesProvider = ({ children }) => {
  const [favorites, setFavorites] = useState([]);
  const [favoritesID, setFavoritesID] = useState({});

  useEffect(() => {
    firebase.auth().onAuthStateChanged(function(user) {
      if (user) {
        let favorites = db.collection('subscribed').doc(user.uid);

        favorites.onSnapshot(
          doc => {
            const data = doc.data();
            if (data) {
              setFavoritesID(data);
              setFavorites(
                Object.values(data).sort((a, b) => {
                  return new Date(b.addedAt) - new Date(a.addedAt);
                })
              );
            }
          },
          err => {
            console.log(`Encountered error: ${err}`);
          }
        );
      } else {
        setFavorites([]);
        setFavoritesID({});
      }
    });
  }, []);

  return (
    <FavoritesContext.Provider
      value={{
        favorites,
        favoritesID
      }}
    >
      {children}
    </FavoritesContext.Provider>
  );
};

export default FavoritesProvider;
